import _ from 'lodash'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { Route, Switch } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import { ViewsIndex as ViewPage } from 'browser/app/pages/app/views'
import { ViewContext } from 'browser/contexts/view-context'

const SentryRoute = Sentry.withSentryRouting(Route);

interface ISettingsProps extends IBaseProps {
  match: any
}

export class FirmPage extends React.Component<ISettingsProps, any> {
  public render() {
    const { match } = this.props
    return (
      <Switch>
        <SentryRoute
          path={`${match.url}/view/:viewId/custom/:customViewId`}
          render={this.handleRenderViewPage}
        />
        <SentryRoute
          path={`${match.url}/view/:viewId`}
          render={this.handleRenderViewPage}
        />
      </Switch>
    )
  }

  private handleRenderViewPage = (props: React.ComponentProps<typeof ViewPage>) => {
    return (
      <ViewContext.Provider value={{ basePath: this.props.match.url }}>
        <ViewPage {...props}></ViewPage>
      </ViewContext.Provider>
    )
  }

  private renderEntityViewNavLink(viewId: unknown, entityId: unknown, label: string) {
    const { match } = this.props
    return (
      <NavLink
        activeClassName="is-active"
        className="c-sideNavigationBarItem c-sideNavigationBarItem--white"
        to={{
          pathname: `${match.url}/view/${viewId}`,
          search: `?entityId=${entityId}`,
        }}
      >
        <div className="c-sideNavigationBarItem-label">{label}</div>
      </NavLink>
    )
  }
}
